<template>
  <div v-if="mode === 'edit'">
    <div>
      <h3>
        Hints: (optional)
      </h3>
      <LatexEdit ref="latexedit" :init="question.ansData.open.hint" @inserted="() => {}" @view="(v) => { $emit('view', v); $emit('saveTo', { obj: question.ansData.open, key: 'hint' }); }" @text="(v) => { question.ansData.open.hint = v }"></LatexEdit>
    </div>
    <div>
      <h3>
        Example Answer:  (optional)
      </h3>
      <div>
        <textarea style="width: 100%; height: 200px;" type="text" v-model="question.ansData.open.exampleAnswer"></textarea>
      </div>
    </div>
  </div>
  <div v-else-if="mode === 'view' || mode === 'mark'">
    <div v-if="mode === 'view'">
      <div v-if="question.ansData.open.hint">
        <div>
          <h3>
            Hint:
          </h3>
        </div>
        <div>
          <Latex ref="latex" :latex="question.ansData.open.hint"></Latex>
        </div>
      </div>
      <div>
        <h3>
          Your Answer:
        </h3>
        <div>
          <textarea :disabled="!!result" style="width: 100%; height: 200px;" type="text" v-model="question.ansData.open.ans"></textarea>
        </div>
      </div>
    </div>

    <div v-if="mode === 'mark'">
      <div v-if="question.cleanData.open.hint">
        <div>
          <h3>
            Hint:
          </h3>
        </div>
        <div>
          <Latex ref="latex" :latex="question.cleanData.open.hint"></Latex>
        </div>
      </div>
      <div>
        <h3>
          Your Answer:
        </h3>
        <div>
          <textarea :disabled="!!result" style="width: 100%; height: 200px;" type="text" v-model="question.cleanData.open.ans"></textarea>
        </div>
      </div>
      <div>
        <MyButton :disabled="!!result" @click="$emit('submit', question)">Submit My Answer</MyButton>
      </div>
    </div>

    <div v-if="result">
      <h3>
        Result
      </h3>
      <div>
        <h4>Your Answer</h4>
        <div>{{ result.yourAnswer }}</div>
      </div>
      <div v-if="false">
        <h4>Example Answer</h4>
        <div>{{ result.exampleAnswer }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'element-ui'
import * as QS from '../compos/question.js'

export default {
  components: {
    MyButton: Button,
    Latex: require('../compos/Latex.vue').default,
    LatexEdit: require('../compos/LatexEdit.vue').default
  },
  props: {
    mode: {
      default: 'edit'
    },
    question: {
      required: true
    }
  },
  data () {
    return {
      result: false
    }
  },
  watch: {
    question: {
      deep: true,
      handler () {
        if (this.question.ansData && this.question.ansData.open && this.mode === 'mark') {
          this.markQuestion()
        }
      }
    }
  },
  methods: {
    getAnsList (str) {
      return str.split('\n').filter(t => t !== '').map((line, i) => {
        return {
          int: i,
          line
        }
      })
    },
    makeResult () {
      this.result = QS.markOpenEnd(this.question.cleanData.open.ans, this.question.ansData.open)
      this.$forceUpdate()
    },
    markQuestion () {
      this.makeResult()
      this.$emit('answered', this.result)
    }
  }
}
</script>

<style>

</style>
